import type { DocumentationTab } from './types';
import { spinLightTheme } from '../../theme/spinTheme';

export const DOCUMENTATION_TABS: DocumentationTab[] = [
  {
    key: 'documentation',
    label: 'Organizacional',
    accent:
      spinLightTheme.getTheme('v5')?.palette?.secondary?.main || '#ff6700',
  },
  {
    key: 'library',
    label: 'Librerías',
    accent: spinLightTheme.getTheme('v5')?.palette?.primary?.main || '#5600d9',
  },
];
